'use strict';

module.exports = {
  'FOOD_AND_BEVERAGE': 'F&B',
  'NON_FOOD_AND_BEVERAGE': 'Non-F&B',
  'NONE': 'Not taxed'
};